import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mr-2"
};
const _hoisted_2 = {
    key: 0,
    class: "ta-c mt-2 empty-text"
};
import SelectedRequestMapItem from '@/entity/SelectedRequestMapItem';
import { pStore } from '@/pinia';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BrgMapAddressItem',
    setup(__props) {
        const pRequestMap = pStore.piniaRequestMap;
        const { addressList, } = storeToRefs(pRequestMap);
        const isActiveItem = (id) => pRequestMap.formData.selectedAddress?.id === id;
        const cssClass = (id) => ({
            'cy-address-item': true,
            [`cy-address-item-${id}`]: true,
            'brg-color-blue-800': isActiveItem(id),
        });
        /**
         * 도로명 주소
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const createRoadNameText = (item) => {
            const addr = item.address;
            return addr.getFullAddress('ROAD_NAME');
        };
        /**
         * 지번 주소
         */
        const createLotNumberText = (item) => {
            const addr = item.address;
            return addr.getFullAddress('LOT_NUMBER');
        };
        /**
         * 주소 아이템 클릭 이벤트
         */
        const handleClickAddressItem = (item) => {
            if (pRequestMap.formData.selectedAddress?.id === item.id) {
                pRequestMap.formData.selectedAddress = null;
                pRequestMap.publishUpdateMapPosition();
                return;
            }
            const newItem = new SelectedRequestMapItem(item);
            pRequestMap.formData.selectedAddress = newItem;
            pRequestMap.publishUpdateMapPosition();
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_component_v_list, { density: "compact" }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addressList), (item) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                class: _normalizeClass(["body2-text", cssClass(item.id)]),
                                key: item.id,
                                value: item.id,
                                active: isActiveItem(item.id),
                                onClick: ($event) => (handleClickAddressItem(item))
                            }, {
                                prepend: _withCtx(({ isActive }) => [
                                    isActive
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                            _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                                    _createTextVNode(" mdi-check-bold ")
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [0]
                                            })
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(createLotNumberText(item)) + " ", 1 /* TEXT */),
                                            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                            _createCommentVNode(" 신주소 필요시 사용 {{ createRoadNameText(item) }} ")
                                        ]),
                                        _: 2 /* DYNAMIC */,
                                        __: [1]
                                    }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "class", "active", "onClick"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }),
                (_unref(addressList).length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 데이터 없음 "))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
